import type { Row, RowData, Table } from '@tanstack/react-table'
import type { VirtualItem } from '@tanstack/react-virtual'
import { useEffect } from 'react'

export type VisibleRows<T extends RowData> = Array<Row<T>>
export type VisibleRowsChangeHandler<T extends RowData> = (visibleRows: VisibleRows<T>) => void

export const useVisibleRows = <T extends RowData>(
  virtualRows: Array<VirtualItem>,
  table: Table<T>,
  onVisibleRowsChange?: VisibleRowsChangeHandler<T>,
) => {
  useEffect(() => {
    const newVisibleRows = virtualRows
      .map((vRow) => table.getRowModel().rows[vRow.index])
      .filter((row): row is Row<T> => !!row)

    if (onVisibleRowsChange) {
      onVisibleRowsChange(newVisibleRows)
    }
  }, [virtualRows, table, onVisibleRowsChange])
}
